import React, {useEffect, useRef, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    ORDER_PLACE as PLACES,
    ORDER_PLACE as places,
    procStatuses
} from "../../util/Constants.js";
import {
    addMinutes,
    calculatePercentageDiscount,
    calculateSubtotalPrice,
    findMobileOperatingSystemAndGetLink,
    findReturnable,
    renderProducts
} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import * as ProductService from "../../services/ProductService";
import Moment from "react-moment";
import {DATE_FORMAT} from "../../util/DateUtil";
import BrandingWatermark from "../../components/BrandingWatermark";
import locationIcon from "../../assets/img/icon_location_2.svg";
import iconCheckMark from "../../assets/img/icon_checkmark_white.svg";
import iconClosed from "../../assets/img/icon_closed_red.svg";
import iconPhone from "../../assets/img/icon_phone_black.svg";
import iconZoniz from "../../assets/img/icon_zoniz_white.svg";
import iconZonizLocation from "../../assets/img/icon_zoniz_location.svg";
import iconPickupSpot from "../../assets/img/icon_pickup_spot.svg";
import loyaltyPointImg from "../../assets/img/loyalty-point.svg";
import loyaltyBackgroundImg from "../../assets/img/loyalty-background.png";
import iconBell from "../../assets/img/icon_bell.svg"
import ThankYouActionsbarBarPickup from "../../components/Actionsbar/ThankYouActionsbarBarPickup";
import NotificationSound from "../../assets/audio/notification.mp3";
import {useNavigate} from "react-router";

function BarPickupThankYou(props) {
    const navigateTo = useNavigate();
    const currency = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).currency:null;
    const shopLanguage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).lang:null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const shopAddress = shopDetails ? (typeof shopDetails.data.address !== "undefined" ? shopDetails.merchantConfig.barPickupDetails : null) : false;
    const barPickupPic = shopDetails ? (typeof shopDetails.merchantConfig.barPickupPic !== "undefined" ? shopDetails.merchantConfig.barPickupPic : null) : false;
    const timeForBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.timeForBarPickup !== "undefined" ? shopDetails.merchantConfig.timeForBarPickup : null) : false;

    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig.showDownloadApp !== "undefined" ? shopDetails.merchantConfig.showDownloadApp : null) : false;
    const visible = "visible";
    const hidden = "hidden";

    const allOrderProductsStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)?JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS)):null;
    const [state, setState] = useState({
        currentStyle:hidden,
        loading: false,
        allOrderProducts: allOrderProductsStorage,
        oid:allOrderProductsStorage?.oid,
        procStatus:allOrderProductsStorage?.procStatus,
        created: allOrderProductsStorage?.created,
        lastMod:allOrderProductsStorage?.lastMod,
        pickupDate: allOrderProductsStorage?.pickupDate,
        discount: allOrderProductsStorage?.discount,
        tips: allOrderProductsStorage?.tips,
        paymentMethod: allOrderProductsStorage?.paymentMethod,
        place: allOrderProductsStorage?.place,
        address:allOrderProductsStorage?.address,
        contact:allOrderProductsStorage?.contact,
        name:allOrderProductsStorage?.name,
        deliveryFee:allOrderProductsStorage?.deliveryFee,
        comment:allOrderProductsStorage?.procStatus ==  procStatuses.DECLINED ? allOrderProductsStorage.comment : null,
    });
    
    const audioPlayer = useRef(null);


    const playAudio = () => {
        audioPlayer.current.play();
    }
    const checkIfOrderWasChanged = async () => {
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "fromDate": yesterday,
            // "procStatus": ["OPEN", "CONFIRMED", "READY", "DELIVERED"]
        }

        const response = await ProductService.getAllProductsOrders(body);
        if (response.ok) {
            let currentOrder = null;
            const storageCurrentOrderId = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID);
            for(let i=0; i < response.data.orders.length;i++){
                const o = response.data.orders[i];
                if(o.oid === storageCurrentOrderId){
                    currentOrder = o;
                    break;
                }
                if(currentOrder === null && o.procStatus === "OPEN"){
                    currentOrder = o;
                }

            }

            if (currentOrder === null) {
                navigateTo(PATH.MAIN);
                return null;
            }

            if (currentOrder.lastMod !== state.allOrderProducts?.lastMod) {
                setState({
                    ...state,
                    oid:currentOrder?.oid,
                    procStatus:currentOrder?.procStatus,
                    created: currentOrder?.created,
                    lastMod:currentOrder?.lastMod,
                    pickupDate: currentOrder?.pickupDate,
                    discount: currentOrder?.discount,
                    tips: currentOrder?.tips,
                    paymentMethod: currentOrder?.paymentMethod,
                    place: currentOrder?.place,
                    address:currentOrder?.address,
                    contact:currentOrder?.contact,
                    name:currentOrder?.name,
                    deliveryFee:currentOrder?.deliveryFee,
                    comment:currentOrder?.procStatus ==  procStatuses.DECLINED ? currentOrder.comment : null,
                    allOrderProducts: currentOrder
                });
                StorageService.setItem(LOCALSTORAGE_ITEMS.ALL_ORDER_PRODUCTS, JSON.stringify(currentOrder));
            }
        }
    }

    useEffect(() => {
        checkIfOrderWasChanged();
        StorageService.setItem(LOCALSTORAGE_ITEMS.PLAY_SOUND, false);
        if (shopDetails === null) {
            navigateTo(PATH.MAIN);
        }
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.THANK_YOU,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.THANK_YOU
        });

        let delayDebounceFn = null;
        delayDebounceFn = setInterval(() => {
            checkIfOrderWasChanged();
        }, 10000)
        return () => clearInterval(delayDebounceFn);

    }, []);


    //todo check if this approach works
    useEffect(() => {

        const handlePopstate = () => {
            if (window.history.state && window.history.state.action === 'POP') {
                if (state.procStatus === procStatuses.DELIVERED) {
                    navigateTo(PATH.MAIN);
                } else {
                    navigateTo(PATH.ALL_PRODUCTS);
                }
            }
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [navigateTo, state.procStatus]);


    useEffect(() => {
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.PLAY_SOUND) === "false" && state.procStatus) {
            StorageService.setItem(LOCALSTORAGE_ITEMS.PLAY_SOUND, true);
        }else if (StorageService.getItem(LOCALSTORAGE_ITEMS.PLAY_SOUND) === "true" && state.procStatus === procStatuses.READY) {
            playAudio();
        }
    }, [state.procStatus]);




    const getTotalProducts = (allOrderProducts) => {
        let totalProducts = 0;
        allOrderProducts?.forEach(product => {
            if (product.status !== "CANCELED") {
                totalProducts+=product.quantity;
            }else{
                totalProducts-=product.quantity;
            }
        })
        return totalProducts;
    }

    let  loyaltyContainerBg = {
        backgroundImage: 'url(' + loyaltyBackgroundImg + ')',
    };

    const getEstimatedPickupTime = () => {
        if (state.pickupDate && state.place === places.BAR) {
            return  <Moment
                format={DATE_FORMAT.HOUR_MINUTES}
                date={state.pickupDate}
            />
        }else {
            return  <Moment
                format={DATE_FORMAT.HOUR_MINUTES}
                date={addMinutes(new Date(state.created),timeForBarPickup)}
            />
        }
    }



    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }


    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="OrderDetails"/>}
                hasBackBtn={false}
            />

            <div className={state.currentStyle+" modal-overlay "} onClick={()=> closeModal()}>   </div>
            <div data-qa="bar-pickup-location-modal" className="modal img-modal">
                    <span onClick={() => closeModal()} className="fixed-close-btn">&times;</span>
                    <div className="modal-title">{shopAddress}</div>
                    <div className="modal-img"><img src={barPickupPic} alt="bar pickup"/></div>
                    <div className="modal-url">
                        <a target="_blank" href={shopDetails.data.loc?.coordinates ? "https://www.google.com/maps/search/?api=1&query="+shopDetails.data.loc?.coordinates[0][1]+","+shopDetails.data.loc?.coordinates[0][0] : void(0)}
                            className="row address-link" data-qa="bar-pickup-modal-address-link">
                            <img height="24" alt="zoniz location" src={iconZonizLocation}/>&nbsp;
                            <h3 className="url"><FormattedMessage id="OpenMap"/></h3>
                        </a>
                    </div>
            </div>
            {state.allOrderProducts && <main className="page-content thank-you-page-content">
                <div className="container-title">
                    {JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)).title}
                </div>
                {shopDetails.data?.phone && <div className="container-phone">
                    <a href={"tel:" + shopDetails.data.phone}>

                        <img alt="phone icon" src={iconPhone}/>
                        <h3 className="phone">{shopDetails.data.phone}</h3>
                    </a>
                </div>}
                <div className="container-table-and-order-id">
                    <h3 className="faded-text">
                        {state.place === places.BAR ? <FormattedMessage id="BarPickup"/> : state.place === PLACES.TAKEAWAY || state.place === PLACES.TAKE_AWAY ? <FormattedMessage id="Takeaway"/> : state.place},&nbsp;
                        <FormattedMessage id="OrderNumber"/> {StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)}
                    </h3>
                </div>
                {state.procStatus == procStatuses.DELIVERED  && <div className="container-date-and-time">
                    <h3 className="faded-text">
                        <Moment
                            format={DATE_FORMAT.DAY_MONTH_YEAR_HOUR_MINUTES}
                            date={state.lastMod}
                        />
                    </h3>
                </div>}

                <div className="container-waiter-msg">

                    {/*PICKUP/TAKEAWAY OPEN*/}
                    { state.procStatus == procStatuses.OPEN && state.place == places.BAR && <div className="text-open">
                        <h3><FormattedMessage id="YourOrderWasSent"/></h3>
                        <h3><FormattedMessage id="YouWillReceiveConfirmationSoon"/></h3>
                        {shopLanguage === "ro" && <h3><FormattedMessage id="PaymentMethodAtLocation" values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/></h3>}
                    </div>}
                    {/*PICKUP/TAKEAWAY  OPEN*/}

                    {/*PICKUP/TAKEAWAY CONFIRMED*/}
                    { state.procStatus == procStatuses.CONFIRMED && state.place == places.BAR && <div className="text-confirmed">
                        <h3><FormattedMessage id="YourOrderHasBeenConfirmed"/></h3>
                        <h3><FormattedMessage id="WeArePreparingIt"/></h3>
                        {shopLanguage === "ro" && <h3><FormattedMessage id="PaymentMethodAtLocation" values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/></h3>}
                    </div>}
                    {/*PICKUP/TAKEAWAY  CONFIRMED*/}

                    {/*PICKUP/TAKEAWAY READY*/}
                    { state.procStatus == procStatuses.READY && state.place == places.BAR && <div className="text-ready">
                        <div className="row">
                            <div className="icon-col col">
                                <img className="bell-icon" src={iconBell} alt=""/>
                            </div>
                            <div className="col">
                                <h3 className="uppercase"><FormattedMessage id="YourOrderIsReady"/></h3>
                                <h3 className="uppercase"><FormattedMessage id="PickItBeforeItGetsCold"/></h3>
                                {shopLanguage === "ro" && <h3><FormattedMessage id="PaymentMethodAtLocation" values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/></h3>}
                            </div>
                        </div>

                    </div>}
                    {/*PICKUP/TAKEAWAY  READY*/}

                    {/*PICKUP/TAKEAWAY DELIVERED*/}
                    { state.procStatus == procStatuses.DELIVERED && state.place == places.BAR && <div className="text-delivered">
                        <div className="row">
                            <div className="icon-col col">
                                <img className="icon-checkmark" src={iconCheckMark} alt=""/>
                            </div>
                            <div className="col">
                                <h3>
                                    {state.paymentMethod.toLowerCase() === "online" ?
                                        <FormattedMessage id="TheOrderHasBeenPaidOnline"/>
                                        :
                                        <FormattedMessage id="TheOrderHasBeenPaidBy"
                                                          values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/>
                                    }
                                </h3>
                                <h3><FormattedMessage id="WeHopeYouEnjoyedIt"/></h3>
                            </div>
                        </div>

                    </div>}
                    {/*PICKUP/TAKEAWAY  DELIVERED*/}


                    {/*PICKUP DECLINED*/}
                    { state.procStatus == procStatuses.DECLINED && state.place == places.BAR &&
                    <div className="text-declined">
                        <div className="row">
                            <div className="col icon-col">
                                <img className="icon-closed" src={iconClosed}/>
                            </div>
                            <div className="col">
                                <h3> <FormattedMessage id="YourOrderHasBeenDeclined"/>
                                </h3>
                                <h3><FormattedMessage id="DecliningReason"/>&nbsp;{state.comment}</h3>
                                <h3><FormattedMessage id="PaymentMethodToTheWaiter" values={{paymentMethod: state.paymentMethod?.toLowerCase()}}/></h3>
                            </div>
                        </div>
                    </div>
                    }
                    {/*PICKUP DECLINED*/}

                </div>
                <>
                    <div style={loyaltyContainerBg} className="loyalty-container">
                        <div style={{backgroundImage: "url('" + loyaltyPointImg + "')"}} className="loyalty-point-img"></div>
                        <div className="loyalty-text">
                            {<FormattedMessage id="DownloadTheAppToEarnCampaignPoints"/>}
                            <a target="blank" href={findMobileOperatingSystemAndGetLink()}><img src={iconZoniz}/></a>

                        </div>
                    </div>
                </>


                {state.place == places.BAR && state.procStatus!== procStatuses.DELIVERED && <div className="container-delivery-time pickup">
                    <h3>{ <FormattedMessage id="PickupAround" values={{pickupHour: getEstimatedPickupTime()}}/>}&nbsp;
                    </h3>

                    <a onClick={() => openModal()}
                       className="row address-link" data-qa="bar-pickup-open-adress-modal"><img height="24" src={iconPickupSpot}/><h3 className="address"><FormattedMessage id="ShowPickupSpot"/></h3>
                    </a>
                </div> }

                {state.place == places.BAR && state.procStatus== procStatuses.DELIVERED && <div className="container-delivery-time pickup">
                    <h3>{ <FormattedMessage id="PickedUpAt" values={{pickupHour:  <Moment
                            format={DATE_FORMAT.HOUR_MINUTES}
                            date={state.lastMod}
                        />}}/>}&nbsp;
                    </h3>
                    <a target="_blank" href={shopDetails.data.loc?.coordinates ? "https://www.google.com/maps/search/?api=1&query="+shopDetails.data.loc?.coordinates[0][1]+","+shopDetails.data.loc?.coordinates[0][0] : void(0)}
                       className="row address-link" data-qa="bar-pickup-open-adress-modal"><img height="24" src={locationIcon}/><h3 className="address">{shopDetails.data.address}</h3></a>
                </div> }

                <div className="order-details-card no-bg">
                    <div className="card-content">
                        {
                            renderProducts(state.allOrderProducts)
                        }

                        {state.discount &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={calculateSubtotalPrice(state.allOrderProducts) / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className={`row discount-row ${findReturnable(state.allOrderProducts.products) ? 'mb-0' : ''}`}>
                                 <span className="subtotal-label">
                                      <FormattedMessage
                                          id="Discount"
                                      />
                                </span>
                                <span className="discount-percentage">
                                    &nbsp;{calculatePercentageDiscount(state.allOrderProducts)}%
                                </span>
                                <span className="total-price">-
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={state.discount / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>

                            {findReturnable(state.allOrderProducts.products) && <div className="row smaller-txt">
                               <i><FormattedMessage id="DiscountNotAppliedToReturnableExtras"/></i>
                            </div>
                            }

                        </div>
                        }

                        {state.tips &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={calculateSubtotalPrice(state.allOrderProducts, true) / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                    <FormattedMessage id="Tip"/>
                                </span>
                                <span className="total-price"> + &nbsp;
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={state.tips / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                        </div>
                        }
                    

                        {state.deliveryFee &&
                        <div className="subtotal-and-discount-container">
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="Subtotal"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={calculateSubtotalPrice(state.allOrderProducts, true, true) / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>
                            <div className="row subtotal-row">
                                <span className="subtotal-label">
                                  <FormattedMessage
                                      id="DeliveryFee"
                                  />
                                </span>
                                <span className="total-price">
                                    <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                        <FormattedNumber
                                            value={state.deliveryFee / 100.0}
                                            style="currency"
                                            minimumFractionDigits={2}
                                            maximumFractionDigits={2}
                                            currency={currency}/>
                                    </IntlProvider>
                                </span>
                            </div>

                        </div>
                        }

                        <div className="total-container row">
                            <span className="total-prod-nr">{
                                getTotalProducts(state.allOrderProducts.products)
                            }&nbsp;</span>
                            <span className="total-prod-label">{getTotalProducts(state.allOrderProducts.products) !==1 ?  <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                            <span className="total-price">
                                {<FormattedMessage id="Total"/>}&nbsp;
                                <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                 <FormattedNumber
                                     value={state.allOrderProducts.price / 100}
                                     style="currency"
                                     minimumFractionDigits={2}
                                     maximumFractionDigits={2}
                                     currency={currency} />
                                 </IntlProvider>
                            </span>
                        </div>
                    </div>
                </div>
                <BrandingWatermark/>
            </main>}
            <ThankYouActionsbarBarPickup
                isVisible={true}
                btnClassName={"btn btn-default btn-xl"}
                btnName={<FormattedMessage id="StartNewOrder"/>}
                showDownloadApp={showDownloadApp}
            ></ThankYouActionsbarBarPickup>
            <audio ref={audioPlayer} src={NotificationSound} />
        </>


    );
}

export default BarPickupThankYou;
